import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function AsceSort(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="9"
        height="13"
        viewBox="0 0 9 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.34681 8.96094C0.914265 8.96094 0.524309 8.69293 0.358781 8.28189C0.193253 7.87085 0.284749 7.39772 0.590606 7.08312L3.79892 3.78312C4.21656 3.35354 4.89369 3.35354 5.31133 3.78312L8.51964 7.08312C8.82549 7.39772 8.91699 7.87085 8.75146 8.28189C8.58593 8.69293 8.19598 8.96094 7.76343 8.96094H1.34681Z"
          fill="#173E96"
        />
      </svg>
    </SvgIcon>
  );
}
